import admin_console from './admin-console/index.js';
import demo_app from './demo-app.js';
import oidc from './oidc.js';
const translation = {
    admin_console,
    demo_app,
    oidc,
};
export default translation;
